module.exports = __webpack_public_path__ + "img/1F615.29926739.svg";